import { create, test, enforce, only, skipWhen } from 'vest'
import isEmail       from 'validator/es/lib/isEmail'
import isTaxID       from 'validator/es/lib/isTaxID'

enforce.extend({ isEmail, isTaxID })

const suite = create('RegisterLandlord', (data = {}, field) => {
    // Todo: find a way to include i18n here instead of passing language as a prop
    const mandatoryMessage = data.language.value === 'en' ? 'This field is mandatory' : 'Detta fält är obligatoriskt'
    const invalidSSNMessage = data.language.value === 'en' ? 'Invalid SSN (use 10 digits)' : 'Ogiltigt personnummer (Ange 10 siffror)'
    const invalidEmailMessage = data.language.value === 'en' ? 'Invalid email' : 'Ange en giltig e-postadress'
    const emailAlreadyInUseMessage = data.language.value === 'en' ? 'Email already in use' : 'E-postadressen är upptagen'
    const invalidPasswordMessage = data.language.value === 'en' ? 'Invalid password' : 'Ogiltigt lösenord'
    const passwordDoNotMatchMessage = data.language.value === 'en' ? 'Passwords do not match' : 'Lösenorden matchar inte'

    only(field)

    if (data.hasNonSwedishSSN) {
        test('ssn', mandatoryMessage, () => enforce(data.ssn).isNotEmpty())
    } else {
        test('ssn', invalidSSNMessage, () => enforce(data.ssn).isTaxID('sv-SE'))
    }

    test('first_name', mandatoryMessage, () => enforce(data.first_name).isNotEmpty())
    test('last_name', mandatoryMessage, () => enforce(data.last_name).isNotEmpty())
    test('street_address', mandatoryMessage, () => enforce(data.street_address).isNotEmpty())
    test('zip', mandatoryMessage, () => enforce(data.zip).isNotEmpty())
    test('city', mandatoryMessage, () => enforce(data.city).isNotEmpty())
    test('email', mandatoryMessage, () => enforce(data.email).isNotEmpty())
    test('email', invalidEmailMessage, () => enforce(data.email).isEmail())
    test('is_email_ok', emailAlreadyInUseMessage, () => enforce(data.is_email_ok).isTruthy())
    test('cellphone', mandatoryMessage, () => enforce(data.cellphone).isNotEmpty())
    test('password', mandatoryMessage, () => enforce(data.password).isNotEmpty())
    test('password', '', () => enforce(data.password).condition(value => {
        const rules = {
            contains_chars: /[a-zA-Z]/.test(value),
            contains_number: /\d/.test(value),
            validLength: value.length > 5,
            password_valid: false
        }

        if (rules.contains_chars && rules.contains_number && rules.validLength) {
            rules.password_valid = true
        }

        return {
            pass: rules.password_valid,
            message: invalidPasswordMessage
        }
    }))

    test('password_again', mandatoryMessage, () => enforce(data.password_again).isNotEmpty())
    test('password_again', passwordDoNotMatchMessage, () => enforce(data.password_again).equals(data.password));

    skipWhen(!data.hasContactPerson, () => {
        test('contact_person_first_name', mandatoryMessage, () => enforce(data.contact_person_first_name).isNotEmpty())
        test('contact_person_last_name', mandatoryMessage, () => enforce(data.contact_person_last_name).isNotEmpty())
        test('contact_person_email', mandatoryMessage, () => enforce(data.contact_person_email).isNotEmpty())
        test('contact_person_phone', mandatoryMessage, () => enforce(data.contact_person_phone).isNotEmpty())
    })
})

export default suite